import { useLanguage } from "providers/language";
import { Language } from "types/locale";
import lt from "../dictionaries/lt.json";
import en from "../dictionaries/en.json";

const dicts = {
  [Language.Lt]: lt,
  [Language.En]: en,
} as const;

export const useDictionary = () => {
  const { lang } = useLanguage();
  return dicts[lang];
};
